import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/clients`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    let options;
    let idType = typeof(id);
    if (idType !== 'object') {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            }
        };
    } else {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
            params: id,
            paramsSerializer: function (params) {
                return qs.stringify(params, { encode: false });
            },
        };
        id = id.id;
    }

    return axios.get(`${url}/clients/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/clients/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function add (zone) {
    const payload = jsona.serialize({
        stuff: zone,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/clients`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (zone) {
    const payload = jsona.serialize({
        stuff: zone,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/clients/${zone.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/clients/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};
